import CobranzaCrud from './CobranzaCrud'
export {CobranzaCrud}
export default CobranzaCrud
